// List of all BC Module Selectors
export const getDefaultFilters = ({ backgroundcheckList }) => backgroundcheckList.searchFilter;
export const getListPageTitle = ({ backgroundcheckList }) => backgroundcheckList.searchLabel;
export const getListAlertModal = ({ backgroundcheckList }) => backgroundcheckList.alert;
export const getListConfirmModal = ({ backgroundcheckList }) => backgroundcheckList.confirmModal;

// Table selectors
export const getCurrentPage = ({ backgroundcheckList }) => backgroundcheckList.searchFilter.Pagination.Page;
export const getSortModel = ({ backgroundcheckList }) => backgroundcheckList.resultTable.appliedFilter.Pagination.Sort;
export const getRowsPerPage = ({ backgroundcheckList }) => backgroundcheckList.resultTable.rowsPerPage;
export const isTableLoading = ({ backgroundcheckList }) => backgroundcheckList.resultTable.loading;
export const getTableData = ({ backgroundcheckList }) => backgroundcheckList.resultTable.data;
export const getTotalCount = ({ backgroundcheckList }) => backgroundcheckList.resultTable.totalCount;
export const getTableSelectedRows = ({ backgroundcheckList }) => backgroundcheckList.resultTable.selectedRows;

// BC Add Form
export const getAddFormData = ({ backgroundcheckAdd }) => backgroundcheckAdd.addForm;
export const getAlertModalData = ({ backgroundcheckAdd }) => backgroundcheckAdd.alert;
export const getShowLoading = ({ backgroundcheckAdd }) => backgroundcheckAdd.loading;

// BC Detail Form
export const hasLoadedData = ({ backgroundcheckDetail }) => backgroundcheckDetail.hasLoadedData;
export const getFormTitle = ({ backgroundcheckDetail }) => backgroundcheckDetail.title;
export const getDetailData = ({ backgroundcheckDetail }) => backgroundcheckDetail.detailForm;
export const getEditable = ({ backgroundcheckDetail }) => backgroundcheckDetail.isEditable;
export const getDetailMode = ({ backgroundcheckDetail }) => backgroundcheckDetail.mode;
export const getDetailAlertModal = ({ backgroundcheckDetail }) => backgroundcheckDetail.alert;
export const getDetailConfirmModal = ({ backgroundcheckDetail }) => backgroundcheckDetail.confirmModal;
export const getDetailInitialSubmit = ({ backgroundcheckDetail }) => backgroundcheckDetail.initialSubmit;
export const getDetailTemporaryDisable = ({ backgroundcheckDetail }) => backgroundcheckDetail.temporarydisable;
export const getDetailEmailTemplate = ({ backgroundcheckDetail }) => backgroundcheckDetail.emailTemplate;

export const validateDetailForm = (values) => {
    let errors = {};

    
    return errors;
}